'use client';
import useValidSearchHistory from '@//data/search/vehicles/useValidSearchHistory';
import StartpageLatestSearchSection from './StartpageLatestSearchSection';

interface MarketMetadata {
  pageLinks: {
    searchPage: string;
  };
}

interface StartpageLatestSearchesContentProps {
  marketMetadata: MarketMetadata;
}

const StartpageLatestSearchesContent = ({
  marketMetadata,
}: StartpageLatestSearchesContentProps) => {
  const { validSearches, isLoading, hasValidSearches } = useValidSearchHistory(1);

  // Don't render if no valid searches exist or still loading
  if (isLoading || !hasValidSearches) {
    return null;
  }

  return (
    <>
      {validSearches.map((search, index) => (
        <StartpageLatestSearchSection
          key={search.id}
          search={search}
          marketMetadata={marketMetadata}
          sectionIndex={index}
        />
      ))}
    </>
  );
};

export default StartpageLatestSearchesContent;
